import React from 'react'
import Styled from 'styled-components'

const SmallPage = ({ currentPage = 1, pageSize = 1, onClickArrow }) => {
    return (
        <SmallPg>
            <button onClick={onClickArrow('prev')} className="button"><i className="icon-angle-right" /></button>
            <span className="pg"><b>{currentPage}</b>/{pageSize}</span>
            <button onClick={onClickArrow('next')} className="button"><i className="icon-angle-right" /></button>
        </SmallPg>
    )
}

const SmallPg = Styled.div`
    display: flex;
    align-items: center;

    .pg {
        margin: 0 7px;
        font-size: 14px;
        color: #666;

        b {
            font-weight: 400;
            color: #418ded;
        }
    }
    .button {
        border: 1px solid #c8c8c8;
        font-size: 17px;
        color: #c8c8c8;
        width: 30px;
        height: 30px;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        background: #fff;

        i {
            top: 1px;
        }
        &:first-child {
            i {
                transform: scaleX(-1);
            }
        }
        &:hover {
            color: #418ded;
            border-color: #418ded
        }
    }
`

export default SmallPage



// WEBPACK FOOTER //
// ./src/estimate_list/components/layout/middle_page.js